export default __webpack_public_path__ + "static/media/zebra.050ddac3.png";